import { useRoute, useRouter } from 'vue-router';

import { scrollToHash } from '#/lib/scrollToHash';

/**
 * shell.js 의 `go(id)` + `data-section` 앵커 분기 이관.
 * - 같은 페이지(path 동일): 해당 id 요소로 부드러운 스크롤(헤더 보정).
 * - 다른 페이지: 라우터로 `/#anchor` 이동(이동 후 스크롤은 router scrollBehavior 가 처리).
 *
 * 두 경로 모두 scrollToHash(레이아웃 정착 후 보정) 로 일원화한다 — 같은/다른 페이지가
 * 동일 규칙을 공유해 앵커 정확도의 SSoT 를 한 곳에 둔다.
 */
export function useScrollTo() {
  const route = useRoute();
  const router = useRouter();

  /** 같은 페이지 내 id 요소로 스크롤. 없는 id 는 무시(안전). */
  function scrollToId(id: string): void {
    scrollToHash(id);
  }

  /**
   * 섹션 앵커 이동.
   * @param targetPath  앵커가 속한 라우트 경로(예: '/')
   * @param hash        '#sample' 형태의 해시
   */
  function goToSection(targetPath: string, hash: string): void {
    const id = hash.replace(/^#/, '');
    if (route.path === targetPath) {
      scrollToId(id);
    } else {
      void router.push({ path: targetPath, hash });
    }
  }

  return { scrollToId, goToSection };
}
